class SwiperSlider extends HTMLElement {
  constructor(){
      super();
      this.options = this.getAttribute('data-swiper') ? JSON.parse(this.getAttribute('data-swiper')) : {};
      this.selector = this.dataset.selector;
  }

  connectedCallback() {
      if (this.querySelector(`.swiper.${this.selector}`)) {
          this.initSlider();
      } 
  }

  initSlider() {
      let swiper;
      if(Swiper !== 'undefined'){
          let swiperElement = this.querySelector(`.swiper.${this.selector}`);
          swiper = new Swiper(swiperElement, this.options);
      }        
  }
}

customElements.define('swiper-slider', SwiperSlider);

class SwiperUtils {
    /**
     * @param {Object} swiper - The swiper instance to be updated.
     */
    static update(swiper){
        swiper.update();
    }
}

class StaticSwiper extends SwiperSlider {
  constructor() {
    super();
    this.tabs = this.dataset.tabs || '';
    this.swiperElement = this.querySelector(`.swiper.${this.selector}`);
    this.paginationContainer = this.swiperElement.querySelector('.swiper-pagination');
  }

  connectedCallback() {
    const swiperEl = this.querySelector(`.swiper.${this.selector}`);
  
    if (swiperEl) {
      if (
        this.options.pagination &&
        typeof this.options.pagination.renderBullet === 'string' &&
        this.options.pagination.renderBullet === 'renderTabBullet'
      ) {
        if (this.tabs && this.tabs.trim() !== '') {
          const tabLabels = this.tabs.split(',').map(label => label.trim());
  
          this.options.pagination.renderBullet = function (index, className) {
            return `<span class="${className}" role="tab">${tabLabels[index] || ''}</span>`;
          };
        } else {
          delete this.options.pagination.renderBullet;
        }
      }
  
      this.initSlider();
    }
  }

  initSlider() {
    let swiper;
    if (typeof Swiper !== 'undefined') {
      swiper = new Swiper(this.swiperElement, this.options);
    }

    swiper?.on('slideChange', () => {
      let activeBullet = this.swiperElement.querySelector('.swiper-pagination-bullet-active');

      if (activeBullet && this.paginationContainer) {
        const containerRect = this.paginationContainer.getBoundingClientRect();
        const bulletRect = activeBullet.getBoundingClientRect();

        const offset = bulletRect.left - containerRect.left - containerRect.width / 2 + bulletRect.width / 2;

        this.paginationContainer.scrollBy({
          left: offset,
          behavior: 'smooth'
        });
      }
    });
    this.updateNavigationVisibility();

    // Ricalcola visibilità bottoni al resize
    window.addEventListener('resize', () => {
      this.updateNavigationVisibility();
    });
  }

  updateNavigationVisibility() {
    if (!this.paginationContainer) return;

    const totalWidth = this.paginationContainer.scrollWidth;
    const visibleWidth = this.paginationContainer.clientWidth;

    const shouldHide = totalWidth <= visibleWidth;

    const prevBtn = this.querySelector('.swiper-button-prev');
    const nextBtn = this.querySelector('.swiper-button-next');

    if (prevBtn) prevBtn.style.display = shouldHide ? 'none' : '';
    if (nextBtn) nextBtn.style.display = shouldHide ? 'none' : '';
  }
}

customElements.define('static-swiper', StaticSwiper);

class DinamicSwiper extends SwiperSlider {
  constructor() {
    super();
    this.tabs = this.dataset.tabs || '';
    this.swiperElement = this.querySelector(`.swiper.${this.selector}`);
    this.paginationContainer = this.swiperElement.querySelector('.swiper-pagination');
  }

  connectedCallback() {
    const swiperEl = this.querySelector(`.swiper.${this.selector}`);
  
    if (swiperEl) {
      if (
        this.options.pagination &&
        typeof this.options.pagination.renderBullet === 'string' &&
        this.options.pagination.renderBullet === 'renderTabBullet'
      ) {
        if (this.tabs && this.tabs.trim() !== '') {
          const tabLabels = this.tabs.split(',').map(label => label.trim());
  
          this.options.pagination.renderBullet = function (index, className) {
            return `<span class="${className}" role="tab">${tabLabels[index] || ''}</span>`;
          };
        } else {
          delete this.options.pagination.renderBullet;
        }
      }
  
      this.initSlider();
    }
  }

  initSlider() {
    let swiper;
    if (typeof Swiper !== 'undefined') {
      swiper = new Swiper(this.swiperElement, this.options);
    }

    swiper?.on('slideChange', () => {
      let activeBullet = this.swiperElement.querySelector('.swiper-pagination-bullet-active');

      if (activeBullet && this.paginationContainer) {
        const containerRect = this.paginationContainer.getBoundingClientRect();
        const bulletRect = activeBullet.getBoundingClientRect();

        const offset = bulletRect.left - containerRect.left - containerRect.width / 2 + bulletRect.width / 2;

        this.paginationContainer.scrollBy({
          left: offset,
          behavior: 'smooth'
        });
      }
    });
    this.updateNavigationVisibility();

    // Ricalcola visibilità bottoni al resize
    window.addEventListener('resize', () => {
      this.updateNavigationVisibility();
    });
  }

  updateNavigationVisibility() {
    if (!this.paginationContainer) return;

    const totalWidth = this.paginationContainer.scrollWidth;
    const visibleWidth = this.paginationContainer.clientWidth;

    const shouldHide = totalWidth <= visibleWidth;

    const prevBtn = this.querySelector('.swiper-button-prev');
    const nextBtn = this.querySelector('.swiper-button-next');

    if (prevBtn) prevBtn.style.display = shouldHide ? 'none' : '';
    if (nextBtn) nextBtn.style.display = shouldHide ? 'none' : '';
  }
}

customElements.define('dinamic-swiper', DinamicSwiper);